/* global translate */ 
import React, { Component } from 'react'
import { connect } from 'react-redux'
import translate from '../../classes/lang'

global.isclient && require('./rxSearchBox.css')
const { rxaget, rxChangeSlug, rxChangeSlugSearch , sortArrObj, stringToColour  ,changeColorSVG} = global.rootRequire('classes/ulti')
const { netaBlobsUpdate,chooseGroupAction, setComp, updateRecentSearchGroups, updateGroupsDraft, netaGroupsUpdate, userAddArr } = global.rootRequire('redux')
const { checkNameGroup, checkNameUser, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { rxgetLocal } = global.rootRequire('classes/request')
const { users, addUser } = global.rootRequire('classes/globalUser')
const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default
const workerUnread = global.rootRequire('classes/globalUnread')
const WAIT_INTERVAL = 500

class rxSearchBox extends React.PureComponent {
  constructor(props, context) {
    super(props, context)
    this.state = {
      groups: rxaget(this.props, 'groups', {}),
      groups_origin: rxaget(this.props, 'groups', {}),
      group_id: rxaget(this.props, 'rxgroup.groupid', ''),
      group: rxaget(this.props, 'rxgroup.group', {}),
      rxgroup: rxaget(this.props, 'rxgroup', {}),
      groupsNChatOrigin: rxaget(this.props, 'groupsNChatOrigin', {}),
      searchValue: '',
      groupsSearchArr: [],
      groupsSearchArrDisplay: [],
      groupsSearchBoxClickStatus: rxaget(this.props, 'groupsSearchBoxClickStatus', {}),
      checkSearchValue_IsNumeber: false,
      zgroup_contact_maxHeight: '224px',
      recentSearchGroups: [],
      recentContactGroups: []/*rxaget(this.props, 'groups', {})*/,
      arrPhoneContact: [],   
      arrPhoneContactDisplay: [],   
      countContact: 0,
      pageActive:rxaget(this.props, 'pageActive', ''),
      registeredUsers: rxaget(this.props, 'netaRegisteredUsers.data', []) || [],
      windowHeight: window.innerHeight - 120,
    }
    this.netaContact = rxaget(this.props, 'netaContact.data', {}) || {}
    this.users = users
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.mouseClickFunction = this.mouseClickFunction.bind(this);
    this.state.recentSearchGroups = this.getRecentSearchGroups()

    this.messtyping = ''

    this.checkImage = {}
    const timenow = Math.floor(Date.now() / 1000)
    let checkImageObj = rxaget(this.props, 'netaBlobs.data', {}) || {}
    if (checkImageObj && typeof (checkImageObj) === "object" && Object.keys(checkImageObj).length > 0) {
      for (let keyImg of Object.keys(checkImageObj)) {
        let created_at = rxaget(checkImageObj[keyImg], 'created_at', 0)
        if ((timenow - created_at) < 43200) {
          this.checkImage[keyImg] = checkImageObj[keyImg]
        }
      }
    }

    let groups = this.props.groups
    let groupsTmp 
    if(groups) {
      groupsTmp = rxaget(this.props, 'groups', {}).filter(o => o.type === 3) 
    } else {
      try {
        const groupneta = rxaget(this.props, 'netaGroups', {})
        const arrContacts = []
        const arrGroups = []
        if (groupneta && groupneta.groups) {
          for (const idgroup of Object.keys(groupneta.groups)) {
            if (groupneta.groups[idgroup]) {
              let ogroup = groupneta.groups[idgroup]
              ogroup['group_fullname'] = checkNameGroup(ogroup, users, this.userid)
              if (ogroup && (ogroup.type === 3 || ogroup.type === 5) && !ogroup.avatar_url && rxaget(ogroup, 'occupants_uins', []).length === 2) {
                const arrUins = rxaget(ogroup, 'occupants_uins', [])
                ogroup['partner_id'] = (arrUins[0].toString() === this.userid.toString()) ? arrUins[1] : arrUins[0]
                if(ogroup.type === 3 ){
                  arrContacts.push(ogroup)  
                }                
              }
              arrGroups.push(ogroup)
            }
          }
        }
        groupsTmp = arrContacts
        this.state.groups = sortArrObj(arrGroups, 'last_message.created_at', 'desc')
      } catch (e) { console.log(e) }
    }  

    let contactsUsers = this.props.groupsNChatOrigin
    if(!contactsUsers){
      contactsUsers = []
      if (users && Object.keys(users).length > 0) {
        for (const userid of Object.keys(users)) {
          if (userid !== this.userid) {
            contactsUsers.push(users[userid])
          }
        }
      }
    }  

    this.state.groupsNChatOrigin = contactsUsers

    ////
    let contactGroupsTmp = sortArrObj(groupsTmp, 'last_message.created_at', 'desc')
    this.state.recentContactGroups = contactGroupsTmp
    this.state.recentContactGroupsDisplay = contactGroupsTmp.slice(0,10)

  }

  componentDidMount() {

    this.setCursorSearchBox()
    document.addEventListener("click", this.mouseClickFunction, true);
    window.addEventListener('resize', this.resize.bind(this))
    this.resize()

  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    
  }
  setCursorSearchBox() {
    let chatDiv = document.getElementById('zleft_search_place')
    if(chatDiv){      
      chatDiv.focus() 
      chatDiv.select()
    }     
  }

  componentWillUnmount() {    
    document.removeEventListener("click", this.mouseClickFunction, false);
    window.removeEventListener('resize', this.resize.bind(this))
    this.setState = (state,callback)=>{
      return;
    };
  }

  onClickAddContact(ele){
    this.props.onClickAddContact(ele)
  }
  
  mouseClickFunction(event) {
    let groupsSearchBoxClickStatus = this.state.groupsSearchBoxClickStatus
    let searchValue = this.state.searchValue
    if((groupsSearchBoxClickStatus === true || searchValue.length > 0) && event.target.className != ''){
      let divNameClass = event.target.className
      let divClickFlag = false
      const divNameClassArr = [ 'zleft_search_place darkThemeInput',
                                'zleft_search_place lightThemeInput',
                                'icon32_white','new_chat','ava-span-1',
                                'pavith_nadal',
                                'zgroupitem-contact-rowline clearfix',
                                'ava-usergroup images-static',
                                'ava-span',
                                'zgroup_name',
                                'zgroup_name-contact',
                                'string-theme-color',
                                'zgroup_maininfo',
                                'zgroup_add_contact',
                                'zgroup_add_contact--btn',
                                'dropdown-item',
                                'createNewChatIcon filter_img_class',
                                'ava-group images-static',
                                'zgroup_avatar-contact',
                                'dropdown-item channel'
                                ]
      if (divNameClassArr.includes(divNameClass)) {
        divClickFlag = true
      }
      if (divClickFlag === false) {
        // this.setState({ groupsSearchBoxClickStatus: false,searchValue:'' })
        this.props.searchBoxvalue(false,'')
        document.removeEventListener("click", this.mouseClickFunction, true);
      }
    }

  }

  getRecentSearchGroups() {
    try {
      const netaRecentSearchGroups = global.rxu.json(rxgetLocal('netaRecentSearchGroups'), {}) || {}
      const recentSearchGroupsArr = []
      let recentSearchGroups = []
      for (const idgroup of Object.keys(netaRecentSearchGroups.groups)) {
        if (netaRecentSearchGroups.groups[idgroup]) {
          let ogroup = netaRecentSearchGroups.groups[idgroup]
          ogroup['group_fullname'] = checkNameGroup(ogroup, users, this.userid)
          if (ogroup && (ogroup.type === 3 || ogroup.type === 5) && !ogroup.avatar_url && rxaget(ogroup, 'occupants_uins', []).length === 2) {
            const arrUins = rxaget(ogroup, 'occupants_uins', [])
            ogroup['partner_id'] = (arrUins[0].toString() === this.userid.toString()) ? arrUins[1] : arrUins[0]
          }
          recentSearchGroupsArr.push(ogroup)
        }
      }
      recentSearchGroups = sortArrObj(recentSearchGroupsArr, 'timeSearch', 'desc').slice(0,20)

      return recentSearchGroups
    } catch (e) { }
  }

  groupsSearchBoxClick() {
    if (this.state.searchValue.length === 0) {
      let recentSearchGroups = this.getRecentSearchGroups()
      this.props.searchBoxvalue(true,'')
      this.setState({
        groupsSearchBoxClickStatus: true,
        recentSearchGroups: recentSearchGroups
      })
    }
  }

  async onChangeSearch_bk(e) {
    const _usersinfo = rxaget(global.rxu.json(rxgetLocal('rxusers'), {}), 'users')
    let value = e.target.value
    let groupsSearchBoxClickStatus
    let arrGroups = []
    let arrPhoneContact = []
    let arrPhoneContactId = []
    let isNumberStatus = false
    let zgroup_contact_maxHeight = '224px'

    // if (value.startsWith('0')) {
    //   value = value.replace(value.charAt(0), '+84')
    // }

    if (value.length >= 2 ) {
      // groupsSearchBoxClickStatus = false
      for (let groupObj of this.state.groupsNChatOrigin) {
        let nameContact = checkNameUser(groupObj)
        if (rxaget(groupObj, 'id', '') !== this.userid) {
          if (!isNaN(value) && groupObj.phone.indexOf(value) !== -1) {
            if (groupObj.phone && this.netaContact[groupObj.phone]) {
              arrPhoneContact.push(groupObj)
            }  
            arrPhoneContactId.push(String(groupObj.id))
          }
          if (isNaN(value) && rxChangeSlugSearch(nameContact).indexOf(rxChangeSlugSearch(value)) !== -1) {
            if (groupObj.phone && this.netaContact[groupObj.phone]) {
              arrPhoneContact.push(groupObj)
            }
            arrPhoneContactId.push(String(groupObj.id))
          }
        }

      }

      arrGroups = this.state.groups.filter(o => {
        let occupants_uins = (o.occupants_uins) ? o.occupants_uins : []
        const userId = rxaget(occupants_uins.filter((id) => (id !== rxaget(this.props, 'netaauth.user.id'))), [0])
        const uname_info = rxaget(_usersinfo, [userId], translate('Stranger'))        
        try {
          if (o.group_fullname && rxChangeSlugSearch(o.group_fullname) && (rxChangeSlugSearch(o.group_fullname).indexOf(rxChangeSlugSearch(value)) !== -1 || (rxChangeSlugSearch(rxaget(uname_info, 'phone', '')).indexOf(rxChangeSlugSearch(value)) !== -1 && (o.type === 3)))) {            
            return true
          } else {
              for(let i = 0; i < occupants_uins.length; i++){
                if(arrPhoneContactId.indexOf(occupants_uins[i]) !== -1 ){
                  return true
                }
              }
            return false
          }
        } catch (e) {
          console.log(e)
        }
      })

    } else {
      groupsSearchBoxClickStatus = true
      arrGroups = this.state.groups.filter(o => rxChangeSlugSearch(o.group_fullname).indexOf(rxChangeSlugSearch(value)) !== -1)

    }
    if (!isNaN(value)) {
      isNumberStatus = true
      zgroup_contact_maxHeight = '100%'
    }

    if (arrPhoneContact.length === 0 && value.length >= 2) {
      let jsonUser = await this.searchPhone(value)
      if (jsonUser && rxaget(jsonUser, 'Id', '') !== this.userid) {
        arrPhoneContact.push(jsonUser)
      }
    }
    let arrPhoneContactDisplay = arrPhoneContact.slice(0,20)
    let arrSearchGroups = arrGroups.filter(o => o.type !== 3) 
    let groupsSearchArrDisplay = arrSearchGroups.slice(0,20)
    
    this.props.searchBoxvalue(groupsSearchBoxClickStatus,value)
    this.setState({
      groupsSearchArr: arrSearchGroups,
      groupsSearchArrDisplay: groupsSearchArrDisplay,
      searchValue: value,
      groupsSearchBoxClickStatus: groupsSearchBoxClickStatus,
      checkSearchValue_IsNumeber: isNumberStatus,
      zgroup_contact_maxHeight: zgroup_contact_maxHeight,
      arrPhoneContact: arrPhoneContact,
      arrPhoneContactDisplay: arrPhoneContactDisplay,
    })
  }

  async onChangeSearch(e) {
    let value = e.target.value
    let arrPhoneContact = []
    let arrPhoneContactDisplay = []
    let isNumberStatus = false
    let zgroup_contact_maxHeight = '224px'
    let groupsSearchArr = []
    let groupsSearchArrDisplay = []
    let groupsSearchBoxClickStatus = false
    if(value.length===0){
      groupsSearchBoxClickStatus = true
    }

    // await chatDB.groups.filter((gr) => { if(gr && gr.name) { return (rxChangeSlug(gr?.name).indexOf(rxChangeSlug(value)) !== -1) } })
    // .limit(40)
    // .toArray()
    // .then((result) => {
    //   groupsSearchArr = [...result, ...groupsSearchArr]
    //   groupsSearchArrDisplay = [...result, ...groupsSearchArrDisplay]
    // })

    // await chatDB.users.filter((user) => { if (user && user.phone && user.full_name) { return (rxChangeSlug(user?.phone).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(user?.full_name).indexOf(rxChangeSlug(value)) !== -1) } })
    // .limit(40)
    // .toArray()
    // .then((result) => {
    //   let newArrPhones = result.filter(oPhone => oPhone.id)
    //   arrPhoneContact = [...newArrPhones, ...arrPhoneContact]
    //   arrPhoneContactDisplay = [...newArrPhones, ...arrPhoneContactDisplay]
    // })

    if (value.length >= 2) {
      isNumberStatus = true
      zgroup_contact_maxHeight = '100%'
      let jsonUser = await this.searchPhone(value, arrPhoneContact)

      if (jsonUser) {
        arrPhoneContact.push(jsonUser)
        arrPhoneContactDisplay.push(jsonUser)
      }
    }
    this.setState({ searchValue: value, groupsSearchBoxClickStatus: groupsSearchBoxClickStatus, groupsSearchArr: groupsSearchArr, groupsSearchArrDisplay: groupsSearchArrDisplay,  arrPhoneContact: arrPhoneContact, arrPhoneContactDisplay: arrPhoneContactDisplay })
  }

  async handleTyping(text, arrPhoneContact) {
    this.messtyping = text
    setTimeout(() => {
      if (this.messtyping == text) {
        const api_get_phone = global.rxu.config.get_username
        let phoneRegx = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/
        if (!text.match(phoneRegx)) {
          
          // Search Users
        //  const api_search = global.rxu.config.get_search
           fetch(api_get_phone + '?username=' + text, {
          
        //  fetch(api_search + '?type=1&keywords='+text+'&offset=0&limit=50', {
            method: 'GET',
            headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' } 
          })
          .then(res => res.json())
          .then((json) => {
            try {
              if (json) {
                let arrContacts = json || []
                  arrContacts = json
                let arrContactIds = [] 
                if (json && json.length > 0) {

                  for(const element of arrPhoneContact) {
                    element.Id = element.uid 
                  }

                  let arrContactIds = arrContacts.map(o => o.Id)
                  let newArrPhoneContact = arrPhoneContact.filter(oUser => arrContactIds.indexOf(oUser.Id) === -1)
                  let resultArrPhoneContact = [...json, ...newArrPhoneContact]

                  resultArrPhoneContact = resultArrPhoneContact.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                      t.Id === value.Id
                    ))
                  )

                  this.setState({
                    arrPhoneContact: resultArrPhoneContact,
                    arrPhoneContactDisplay: resultArrPhoneContact
                  })
                }
              }
            } catch(e) {
              console.log(e)
            }
          })
          .catch(er => { console.log('can\'t search users');  return er })

        //  // Search Groups
        //  fetch(api_search + '?type=2&keywords='+text+'&offset=0&limit=50', {
        //    method: 'GET',
        //    headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
        //  })
        //  .then(res => res.json())
        //  .then((json) => {
        //    try {
        //      if (json && json.constructor === Array && json.length >= 0) {
        //        let resultArray = []
        //        let groupsSearchArr = this.state.groupsSearchArr
        //        let groupIdArr = groupsSearchArr.map(g => g.group_id)
              
        //        for (let gCurrent of json) {
        //          if (groupIdArr.indexOf(gCurrent.group_id) === -1 && gCurrent.name) {
        //            gCurrent.group_fullname = gCurrent.name
        //            gCurrent.group_id = gCurrent.group_id.toString()
        //            resultArray.push(gCurrent)
        //          }
        //        }

        //        let groupsNewArr = [...resultArray, ...groupsSearchArr]

        //        groupsNewArr = groupsNewArr.filter((value, index, self) =>
        //          index === self.findIndex((t) => (
        //            t.group_id === value.group_id
        //          ))
        //        )

        //        this.setState({ groupsSearchArr: groupsNewArr, groupsSearchArrDisplay: groupsNewArr })

        //      } else {
        //        console.log('Error search groups')
        //      }
        //    } catch(e) {
        //      console.log(e)
        //    }
        //  })
        //  .catch(er => { console.log('can\'t search groups');  return er })
        }
      } 
    }, 200)
  }

  async searchPhone(vPhone, arrPhoneContact) {
    this.handleTyping(vPhone, arrPhoneContact)
  }

  execChooGroup(group) {
    this.props.chooseGroupAction(group)
    this.props.searchBox_chooseGroup(group)
    this.props.searchBoxvalue(false,'')         
    this.setState({groupsSearchBoxClickStatus: false, searchValue:'' })
    this.props.groupsSearchBoxClick()
    let timeSeach = Date.now()
    this.props.updateRecentSearchGroups(group.group_id, group, timeSeach)
  }

  chooseGroup(group) {
    if (group && group.group_id) {
      chatDB.groups.get({group_id: group.group_id.toString()}).then(groupInDB => {
        if (groupInDB) {
          this.execChooGroup(groupInDB)
        } else {
          const api_group_detail = global.rxu.config.get_groups + '/' + group.group_id
          fetch(api_group_detail, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'TC-Token': this.token,
              Connection: 'Keep-Alive',
              'Accept-Encoding': 'gzip'
            },
            body: null
          }).then(res => res.json()).then((json) => {
            let objUsers = []
            
            if (json && json.Code === 1013) {
              alert(translate('Group not found'))
            } else if (json) {
              if (json && json.users && json.users.constructor === Array && json.users.length > 0) {
                try {
                  let ogroup = rxaget(json, 'Group', {})
                  ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                  ogroup.flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0' // 0 or 1
                  ogroup.flagPin = (ogroup && ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
                  ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp

                  ogroup.received_list = []
                  ogroup.seen_list = []
                  ogroup.occupants_uins = ogroup.occupants_uins.map(String)

                  const arrUins = rxaget(ogroup, 'occupants_uins', [])

                  ogroup['partner_id'] = 0
                  ogroup['avatar_url'] = ogroup.avatar_url || ''
                 
                  let objUsers = []
                  let arrNameTmp = []
                  if (json.users && json.users.constructor === Array && json.users.length > 0) {
                    for (const user of json.users) {
                      if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                        user.full_name = translate('Stranger')
                      }
                      objUsers.push({ id: user.Id, uid: user.Id,  ...user })  

                      let uName = rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')
                      if (uName) {
                        arrNameTmp.push(uName)
                      }

                      addUser(user.Id, { id: user.Id, uid: user.Id,  ...user })

                    }
                  }
                  if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
                    for (const user of json.removed_users) {
                      addUser(user.Id, { id: user.Id, uid: user.Id,  ...user })
                      if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                        objUsers.push({ id: user.Id, uid: user.Id,  ...user })  
                      }
                    }
                  }
                  if (json.Group && json.Group.group_id.toString()) {
                    chatDB.users.bulkPut(objUsers)
                  }

                  ogroup['group_fullname'] = ogroup.name || arrNameTmp.slice(0, 3).join(', ')

                  ogroup.count_unread = 0
                  ogroup.group_id = ogroup.group_id.toString()

                  ogroup.background = ""
                  ogroup.blocked_uins = []
                  ogroup.current_groupcall = null
                  ogroup.description = ""
                  ogroup.flagDetail = false
                  ogroup.last_active_messages = []
                  ogroup.last_messages = []
                  ogroup.last_sos_messages = []
                  ogroup.locations = []
                  ogroup.mode = 0
                  ogroup.muted_uins = []
                  ogroup.pinned_messages = []
                  ogroup.pinned_uins = []
                  ogroup.removed_uins = []
                  ogroup.secrets = []
                  ogroup.status_list = []
                  ogroup.unread_cnt = 0

                  workerUnread.initUnread(ogroup.group_id, '-1')
                  
                  chatDB.groups.add(ogroup, ogroup.group_id.toString()).then(g => {
                    this.execChooGroup(ogroup)
                  }).catch(e => {
                    console.log(e)
                  })
                } catch(e) {}
              }
            } else {
              alert(translate('You are not a member of this group'))
            }
          })
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
  
  createNewChat(partner_id, newContact) {
    let userid = this.userid.toString()
    partner_id = partner_id.toString()

    let params = {
      'type':3,
      'occupants_uins':[partner_id,this.userid.toString()]
    }

    let createdAt = new Date().getTime() * 1000 

    let newUSer = {
      id: rxaget(newContact, 'Id', ''),
      uid: rxaget(newContact, 'Id', ''),
      email: rxaget(newContact, 'email', ''),
      phone: rxaget(newContact, 'phone', ''),
      full_name: rxaget(newContact, 'full_name', ''),
      profile_url: rxaget(newContact, 'profile_url', ''),
      name_contact: rxaget(newContact, 'name_contact', '')
    }
    chatDB.users.get(Number(newUSer.uid)).then(u => {
      if (!u || !u.full_name) {
        chatDB.users.put(newUSer, Number(newUSer.uid))
      }
    })

    rxio.checkGroup(params,async (data) => {
      try {
        let last_message = {
          'attachments': "",
          'created_at': createdAt
        }

        if(data && data.group) {
          let group = data.group
          let group_id = data.group.group_id    
           
          let newnameuser = checkNameUser(newContact) || ''
            group['fullnamegroup'] = (newContact.full_name) ? newContact.full_name : (newnameuser) ? newnameuser : newContact.phone || ''
            group.group_fullname = group['fullnamegroup']

          group.partner_id = partner_id

          let groupInDb = await chatDB.groups.get(group_id.toString())
          if(!groupInDb){
            group.last_message = last_message
            group.isDraft = true

            group.timestamp = (group.last_message && group.last_message.created_at) ? Number(group.last_message.created_at) : (group.updated_at) ? group.updated_at : new Date().getTime() * 1000
            group.flagDraf = '1'
            group.flagPin = '0'
            group.last_sort = '1' + group.flagDraf + group.flagPin + group.timestamp
            
            let newnameuser = checkNameUser(newContact) || ''
            group['fullnamegroup'] = (newContact.full_name) ? newContact.full_name : (newnameuser) ? newnameuser : newContact.phone || ''
            group.group_fullname = group['fullnamegroup']
            group.avatar_url = newContact.profile_url || ''
        
            this.props.updateGroupsDraft(group,group_id)
            this.props.netaGroupsUpdate(group.group_id, group)
            this.props.chooseGroupAction(group)
          } else {
            this.props.chooseGroupAction(group)
          }


        } else {
          let timestamp = new Date().getTime() * 1000
          let objGroup = JSON.parse(JSON.stringify({
            'admin_uins': [userid],
            'avatar_url': newContact.profile_url || '',
            'background': "",
            'blocked_uins': [],
            'count_unread': 0,
            'created_at': createdAt,
            'creator_uin': userid,
            'description': "",
            'group_fullname': (newContact.full_name) ? newContact.full_name : newContact.phone || '',
            'group_id': partner_id,
            'last_active_messages': [],
            'last_message': last_message,
            'last_message_id': "",
            'last_messages': [],
            'last_sos_messages': [],
            'locations': [],
            'mode': 0,
            'muted_uins': [],
            'name': "",
            'occupants_uins':[partner_id.toString(),this.userid.toString()],
            'owner_uin': userid,
            'partner_id': partner_id,
            'pinned_messages': [],
            'pinned_uins': [],
            'received_list': [],
            'removed_uins': [],
            'secrets': [],
            'seen_list': [],
            'status_list': [],
            'type': 3,
            'unread_cnt': 0,
            'updated_at': "",
            'isDraft': true,
            'timestamp': timestamp,
            'flagDraf': '1',
            'flagPin': '0',
            'last_sort': '110'+timestamp
          }))

          let newnameuser = checkNameUser(newContact) || ''
          objGroup['fullnamegroup'] = (newContact.full_name) ? newContact.full_name : (newnameuser) ? newnameuser : newContact.phone || ''
          
          this.props.updateGroupsDraft(objGroup, partner_id)
          this.props.netaGroupsUpdate(objGroup.group_id, objGroup)
          this.props.chooseGroupAction(objGroup)
        }

                      
        this.props.setComp('chat')
      } catch(e) {}
    })
  }

  chooseContact(contact){
    this.props.groupsSearchBoxClick()
    if(this.state.pageActive==='contactPage'){
      this.props.setComp('chat')  
    }
    this.createNewChat(contact.id, contact)
    this.props.searchBoxvalue(false,'')
    // this.setState({groupsSearchBoxClickStatus: false,searchValue:'' })

  }

  createNewChatGroup(type_popup) {
    console.log("cai gi day",type_popup)
   this.props.createNewChatGroup(type_popup)
  }

  disableDrop = event => {
    event.preventDefault();
  }

  scrollRecentContactList(e){
    const container = document.getElementById('csearch_recentContactList')

    if(container && (container.scrollLeft >= 300)){
      let groupsDisplay = this.state.recentContactGroupsDisplay      
      let index = groupsDisplay.length
      let groupsArr = this.state.recentContactGroups.slice(index,index + 10)

      groupsDisplay = [...groupsDisplay, ...groupsArr]
      this.setState({recentContactGroupsDisplay:groupsDisplay})      
    }
  }

  scrollPhoneContactList(e){
    const container = document.getElementById('csearch_phone_contact')
    if(container && (container.scrollTop + container.offsetHeight >= container.scrollHeight - 360)){
      let groupsDisplay = this.state.arrPhoneContactDisplay      
      let index = groupsDisplay.length
      if (this.state.arrPhoneContact.length > 0) {
        let groupsArr = this.state.arrPhoneContact.slice(index,index + 20)
        groupsDisplay = [...groupsDisplay, ...groupsArr]
        this.setState({arrPhoneContactDisplay:groupsDisplay})   
      }
    }
  }

  scrollgroupsSearchList(e){
    const container = document.getElementById('csearch_groupsSearch')

    if(container && (container.scrollTop + container.offsetHeight >= container.scrollHeight - 360)){
      let groupsDisplay = this.state.groupsSearchArrDisplay      
      let index = groupsDisplay.length
      let groupsArr = this.state.groupsSearchArr.slice(index,index + 20)

      groupsDisplay = [...groupsDisplay, ...groupsArr]
      this.setState({groupsSearchArrDisplay:groupsDisplay})      
    }
  }

  addColorToName(name){

    let result =''
    let searchValue = this.state.searchValue    
    
    RegExp.escape = function(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    
    if((searchValue.search(/[\[\]\\.?*+()]/) !== -1)){
      searchValue = new RegExp(RegExp.escape(searchValue), "i")
    }

    if (name.length > 43) {
      name = name.slice(0, 43) + ' ...'
    }
    
    if(/*!(searchValue.search(/[\[\]\\.?*+()]/) !== -1) && */isNaN(searchValue)){
      let regEx = new RegExp(searchValue, "ig")
      let nameArr = name.split(regEx)
      if (name.match(regEx)){
        for (let i = 0; i < nameArr.length; i++){
          if(i === nameArr.length -1){
            result += nameArr[i]
          } else{
            let replaceValue = name.match(regEx)[i]
            result += nameArr[i] + `<span class = 'string-theme-color'>${replaceValue}</span>` //= name.replace(replaceValue, `<span class = 'string-theme-color'>${replaceValue}</span>`);  
          }        
        }  
      } else {
        result = name
      }
    } else{
      result = name
    }

    return result
  }
  resize() {
    this.setState({
      windowHeight: window.innerHeight - 120
    })
  }

  contactIsExist(id){
    try {
      if(this.state.registeredUsers && this.state.registeredUsers.constructor === Array && this.state.registeredUsers.filter(value=> (value.Id == id)).length > 0){
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }

  render () {
    let recentContactGroupsDisplay = this.state.recentContactGroupsDisplay
    
    let searchBoxHeight = this.state.windowHeight//'100%'
    let searchBox_padding= '0px'
    if(this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length === 0 ){
      searchBoxHeight='0px'
      searchBox_padding='50px'
    }
    const linkava = global.rxu.config.get_avatar  

    return (
      <div className='search_contain' style={{height:searchBoxHeight,'paddingBottom':searchBox_padding}}>
        <div className='zleft_searchwrap'>
          <div className='icon_basic_search_area'>
            <img className='icon_basic_search filter_img_class'  src={changeColorSVG('./images/default/icons/search-active.svg')} alt=''/>
          </div>

          <input id ='zleft_search_place' type='search' maxLength='30' placeholder={translate('Search')} 
                className={rxaget(this.props, 'themeBackgroudValue') === 'darkTheme' ? 'zleft_search_place darkThemeInput':'zleft_search_place lightThemeInput'}  
                onChange={e => { this.onChangeSearch(e) }} onClick={e => {this.groupsSearchBoxClick()}} onDrop={this.disableDrop}>
          </input>

          {(this.state.pageActive==='chatPage') && <div className='dropdown'>
            <div className='zleft_edit' >
              <img className='icon32 filter_img_class' src={changeColorSVG('./images/default/icons/edit.svg')} alt=''/>
              <img className='icon32_white' src={changeColorSVG('./images/default/icons/edit40x40.svg')} alt=''/>
            </div>
 
            <div className='dropdown-content'>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item' onClick={e => { this.createNewChatGroup('create_chat') }}>
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-user.svg')} alt=''/>
                  <span className='new_chat' >
                    {translate('New Message')}
                  </span>
                </div>
              </div>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item' onClick={e => { this.createNewChatGroup('create_group') }}>
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-group.svg')} alt=''/>
                  <span className='new_chat' >
                    {translate('New Group Chat')}
                  </span>
                </div>
              </div>
              <div className='rectangle_1827'>
                <div className = 'dropdown-item channel' onClick={e => { this.createNewChatGroup('create_channel') }}>
                  <img  className='createNewChatIcon filter_img_class' src={changeColorSVG('./images/default/icons/icon-channel.svg')} alt=''/>
                  <span className='new_chat' >
                    {translate('New Channel')}
                  </span>
                </div>
              </div>
            </div>
            
          </div>}

        </div>

        <div className={this.state.groupsSearchBoxClickStatus === true && recentContactGroupsDisplay && recentContactGroupsDisplay.length > 0 ? 'rectangle_1512':'rectangle_1512_hiden'}
            id = 'csearch_recentContactList'
            // onScroll={e => this.scrollRecentContactList(e)}
        >
          <div  className='scrollmenu' >
            { recentContactGroupsDisplay && recentContactGroupsDisplay.length > 0 ?
              recentContactGroupsDisplay.map((ele, index) =>{
              return  <div className={'scrollmenu_item'} key={index} onClick={e => { this.chooseGroup(ele) }}>
                  <ul className='ul-item'>
                    <li className='li-item'>
                    <div className='menu_item' >
                      {ele.avatar_url 
                        ? 
                        <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-span-1'
                        onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                        :
                        (users[ele.partner_id] && users[ele.partner_id]['profile_url'] 
                          ? <img src={`${global.rxu.config.cdn_endpoint}` + users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-span-1' 
                          onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}/> 
                           : this.checkImage[linkava + ele.partner_id] && <img src={this.checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-span-1' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                        )
                      }
                      {
                        !(ele.avatar_url || (users[ele.partner_id] && users[ele.partner_id]['profile_url']) )
                        &&<span className='ava-span-1' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
                          {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
                        </span>  
                      }
                    </div>
                    </li>
                    <li >
                      <div className='pavith_nadal'>{  (users[ele.partner_id] && users[ele.partner_id]['name_display']) ? users[ele.partner_id]['name_display'] : rxaget(ele, 'group_fullname', '')}
                      </div>
                    </li>
                  </ul>
                </div>
              })
              :<div></div>
            }     
          </div>
        </div>

        <div className={this.state.groupsSearchBoxClickStatus === true && recentContactGroupsDisplay && recentContactGroupsDisplay.length > 0 ? 'rectangle_1828':'rectangle_1828_hiden'}>
          <div className='searchbox-group-title'>
            {translate('Recent contact')}
          </div>      
        </div>
        
        <div className={this.state.groupsSearchBoxClickStatus === true && recentContactGroupsDisplay && recentContactGroupsDisplay.length > 0 ? 'rectangle_1512':'rectangle_1512_hiden'}
            id = 'csearch_recentContactList'
            // onScroll={e => this.scrollRecentContactList(e)}
        >
          <div  className='scrollmenu' >
            { recentContactGroupsDisplay && recentContactGroupsDisplay.length > 0 ?
              recentContactGroupsDisplay.map((ele, index) =>{
              return  <div className={'scrollmenu_item'} key={index} onClick={e => { this.chooseGroup(ele) }}>
                  <ul className='ul-item'>
                    <li className='li-item'>
                    <div className='menu_item' >
                      {ele.avatar_url 
                        ? 
                        <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-span-1'
                        onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                        :
                        (users[ele.partner_id] && users[ele.partner_id]['profile_url'] 
                          ? <img src={`${global.rxu.config.cdn_endpoint}` + users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-span-1' 
                          onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}/> 
                           : this.checkImage[linkava + ele.partner_id] && <img src={this.checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-span-1' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                        )
                      }
                      {
                        !(ele.avatar_url || (users[ele.partner_id] && users[ele.partner_id]['profile_url']) )
                        &&<span className='ava-span-1' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
                          {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
                        </span>  
                      }
                    </div>
                    </li>
                    <li >
                      <div className='pavith_nadal'>{  (users[ele.partner_id] && users[ele.partner_id]['name_display']) ? users[ele.partner_id]['name_display'] : rxaget(ele, 'group_fullname', '')}
                      </div>
                    </li>
                  </ul>
                </div>
              })
              :<div></div>
            }     
          </div>
        </div>

        <div className={this.state.groupsSearchBoxClickStatus === true  ? 'rectangle_1829':'rectangle_1829_hiden'}>
          <div className='searchbox-group-title'>
            {translate('Recent search')}
          </div>
        </div>

        { 
          this.state.arrPhoneContactDisplay.length > 0 && <div className={this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length > 0 && this.state.checkSearchValue_IsNumeber === false ? 'rectangle_1828':'rectangle_1828_hiden'}>
            <div className='searchbox-group-title'>
              {translate('CONTACT')} 
            </div>      
          </div>
        }
        <div className = {this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length > 0 ?  'rectangle_1512_contact':'rectangle_1512_hiden'} 
            style = {{'maxHeight':this.state.zgroup_contact_maxHeight}}
            id = 'csearch_phone_contact'
            // onScroll={e => this.scrollPhoneContactList(e)}
        >
          { 
            this.state.arrPhoneContactDisplay.length > 0 &&
            this.state.arrPhoneContactDisplay.map((ele, index) => {
            let nameUserInfo = checkNameUser(ele)
            return (ele.id!==this.userid) &&<div className='zgroupitem-contact-rowline clearfix' key={index} >             
              <div className='zgroup_avatar-contact' onClick={e => { this.chooseContact(ele) }}>                      
                { (ele && ele.profile_url) ? 
                    <img src={`${global.rxu.config.cdn_endpoint}` + ele['profile_url']} alt='profile_url' className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} /> 
                  :
                    <span className='ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'id', ''))}` }}> {textAva(rxChangeSlug(nameUserInfo, true))} </span> 
                }
              </div>                
              
              <div className='zgroup_maininfo'>                                  
                {(nameUserInfo.length > 43) && <div rowname-tooltip-position='right' rowname-tooltip={nameUserInfo}>
                  <div className='zgroup_name-contact' onClick={e => { this.chooseContact(ele) }} dangerouslySetInnerHTML={{ __html: this.addColorToName(nameUserInfo) }}></div>
                </div>}
                {(nameUserInfo.length <= 43) && <div className='zgroup_name-contact' onClick={e => { this.chooseContact(ele) }} dangerouslySetInnerHTML={{ __html: this.addColorToName(nameUserInfo) }}></div>}
                {!this.contactIsExist(rxaget(ele, 'id', '').toString()) && <div className='zgroup_add_contact'><div className='zgroup_add_contact--btn' onClick={ e => {this.onClickAddContact(ele)}}>{translate('Add')}</div></div>}
                {/*<div className='divider_area'></div>*/}
              </div>
            </div>
          })}
        </div>
        
        <div className={this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length > 0 ? 'rectangle_1829':'rectangle_1829_hiden'}>
          <div className='searchbox-group-title'>
            {translate('GROUP')}
          </div>
        </div>
        <div className={this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length === 0 ?'searchbox_contactlist_hiden':'searchbox_contactlist'}             
            id = 'csearch_groupsSearch'
            onScroll={e => this.scrollgroupsSearchList(e)}
        >
          {this.state.groupsSearchBoxClickStatus === true && <div>
            { this.state.recentSearchGroups?
              this.state.recentSearchGroups.map((ele, index) =>{
                return((ele.id!==this.userid) &&<div className='zgroupitem-contact-rowline clearfix' key={index} onClick={e => { this.chooseGroup(ele) }} >             
                  <div className='zgroup_avatar-contact'>                      
                    {ele.avatar_url 
                      ? 
                      <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-group images-static'
                      onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                      :
                      (users[ele.partner_id] && users[ele.partner_id]['profile_url'] 
                        ? <img src={`${global.rxu.config.cdn_endpoint}` + users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-usergroup images-static' 
                        onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}/> 
                         : this.checkImage[linkava + ele.partner_id] && <img src={this.checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                      )
                    }
                    {
                      !(ele.avatar_url || (users[ele.partner_id] && users[ele.partner_id]['profile_url']) )
                      &&<span className='ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
                        {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
                      </span>  
                    }
                  </div>                
                  <div className='zgroup_maininfo' rowname-tooltip-position='right' rowname-tooltip={rxaget(ele, 'group_fullname', '')}>                                  
                    <div className='zgroup_name-contact'>{this.addColorToName(rxaget(ele, 'group_fullname', ''))}</div>
                    {/*<div className='divider_area'></div>*/}
                  </div>
                </div>)
              })
              :<div></div>
            }          
          </div>}

          {this.state.groupsSearchBoxClickStatus === false && this.state.searchValue.length > 0 &&<div>
            { this.state.groupsSearchArrDisplay.length > 0 ? (
                this.state.groupsSearchArrDisplay.map((ele, index) =>{
                  return((ele.id!==this.userid) &&<div className='zgroupitem-contact-rowline clearfix' key={index} onClick={e => { this.chooseGroup(ele) }} >             
                    <div className='zgroup_avatar-contact'>                      
                      {ele.avatar_url 
                        ? 
                        <img src={global.rxu.config.get_static + ele.avatar_url} alt='avatar_url' className='ava-group images-static'
                        onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                        :
                        (users[ele.partner_id] && users[ele.partner_id]['profile_url'] 
                          ? <img src={`${global.rxu.config.cdn_endpoint}` + users[ele.partner_id]['profile_url']} alt='profile_url' data-id={'userava' + ele.partner_id} className='ava-usergroup images-static' 
                          onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> 
                           : this.checkImage[linkava + ele.partner_id] && <img src={this.checkImage[linkava + ele.partner_id]['link']} alt='linkava' className='ava-usergroup images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                        )
                      }
                      {
                        !(ele.avatar_url || (users[ele.partner_id] && users[ele.partner_id]['profile_url']) )
                        &&<span className='ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'group_id', ''))}` }}>
                          {textAva(rxChangeSlug(rxaget(ele, 'group_fullname', ''), true))}
                        </span>  
                      }
                    
                    </div>                
                    
                    <div className='zgroup_maininfo'>                                  
                      <div className='zgroup_name-search' dangerouslySetInnerHTML={{ __html: this.addColorToName(rxaget(ele, 'group_fullname', '')) }}></div>
                      <div className='zgroup_desc-search'>{   (rxaget(ele, 'last_message.sender_uin', '') && rxaget(ele, 'last_message.sender_uin', '').toString() === this.userid.toString()) ? translate('You') + ': ' : (rxaget(ele, 'last_message.message', '') && rxaget(ele, 'last_message.sender_uin', '') && this.users[rxaget(ele, 'last_message.sender_uin', '')]) ? (this.users[rxaget(ele, 'last_message.sender_uin', '')]['full_name'] || this.users[rxaget(ele, 'last_message.sender_uin', '')]['phone']) + ': '  : '' } {rxaget(ele, 'last_message.message', '')}</div>
                      <div className='divider_area'></div>
                    </div>
                  </div>)
                })
              ) : (
                <div>
                  {(this.state.arrPhoneContactDisplay && this.state.arrPhoneContactDisplay.constructor === Array && this.state.arrPhoneContactDisplay.length == 0) && <div className='zgroup-emty'>                
                    <div className='zgroup-emty_text' >

                    </div>
                  </div>}
                </div>
              )
            }
          </div>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeBackgroudValue: state.themeBackgroudValue,
  user: state.user,
  netaauth: state.netaauth,
  rxgroup: state.rxgroup,
  netaBlobs: state.netaBlobs,  
  netaGroups: state.netaGroups,
  netaContact: state.netaContact,
  netaRegisteredUsers: state.netaRegisteredUsers
})

const mapDispatchToProps = {
  netaBlobsUpdate,
  chooseGroupAction,
  setComp,
  updateRecentSearchGroups,
  updateGroupsDraft,
  netaGroupsUpdate,
  userAddArr

}

const rxSearchBox_ = connect(
  mapStateToProps,
  mapDispatchToProps
)(rxSearchBox)

export default rxSearchBox_